import create from "zustand";

import checkoutSteps from "../../../../../providers/HelCheckoutSteps";
import { storageLocal as storage } from "../../../../../utils/StorageHandler";
import resolveWebView from "../../../../../utils/webViewRedirect";
import { navigate } from "../../../../shared/LinkComponent";

interface iHeatingOilStepButtons {
    steps: number;
    currentStepIndex: number;
    previousStepIndex: number;
    checkoutStep: string;
    editMode: boolean;
    stepButtonAction: string;
    baseUrl: string;
    setCheckoutStep: (checkoutStep: string) => void;
    setEditMode: (editMode: boolean) => void;
    previousStepVisible: () => boolean;
    setStepButtonAction: (stepButtonAction: string) => void;
    setCurrentStepIndex: (currentStepIndex: number) => void;
}

const useStore = create<iHeatingOilStepButtons>((set, get) => ({
    steps: 3,
    currentStepIndex: 0,
    checkoutStep: "",
    editMode: false,
    baseUrl: "/heizoel/bestellung/",
    stepButtonAction: "",
    previousStepIndex: 0,

    setCheckoutStep: (checkoutStep: string) => {
        set({ checkoutStep: checkoutStep });
    },

    setEditMode: (editMode: boolean) => {
        set({ editMode: editMode });
    },

    previousStepVisible: () => {
        if (
            (get().currentStepIndex === 1 &&
                storage.getBoolean("hel:product-is-premium")) ||
            get().currentStepIndex === 0
        ) {
            return false;
        }
        return true;
    },

    nextStep: (
        produktStepIsValid: () => boolean,
        lieferdetailsStepIsValid: () => boolean,
        deliveryAddressStepIsValid: () => boolean,
        zahlartStepIsValid: () => boolean,
        isAgbValid: () => boolean,
        uebersichtStepIsValid: () => boolean
    ) => {
        const currentStepIndex = get().currentStepIndex;
        if (currentStepIndex + 1 < checkoutSteps.length) {
            const nextStep =
                get().baseUrl + checkoutSteps[currentStepIndex + 1].url;
            const checkoutStep = get().checkoutStep;
            if (checkoutStep === "product" && !produktStepIsValid()) {
                return;
            }
            if (
                checkoutStep === "lieferdetails" &&
                !lieferdetailsStepIsValid()
            ) {
                return;
            }
            if (
                checkoutStep === "lieferadresse" &&
                !deliveryAddressStepIsValid()
            ) {
                return;
            }
            if (checkoutStep === "zahlart" && !zahlartStepIsValid()) {
                return;
            }
            if (
                checkoutStep === "uebersicht" &&
                (!uebersichtStepIsValid() || !isAgbValid())
            ) {
                return;
            }
            void navigate(resolveWebView(nextStep));
        }
    },

    previousStep: () => {
        /*setFormErrors([]);*/
        const path =
            get().baseUrl + checkoutSteps[get().currentStepIndex - 1].url;
        void navigate(resolveWebView(path));
    },

    setStepButtonAction: (stepButtonAction: string) => {
        set({ stepButtonAction: stepButtonAction });
    },

    setCurrentStepIndex: (currentStepIndex: number) => {
        set({ previousStepIndex: get().currentStepIndex });
        set({ currentStepIndex: currentStepIndex });
    },
}));

export default useStore;
